import { createSlice } from '@reduxjs/toolkit';

interface ExtraInitialState {
  selectedWindowId: number;
}

export const windowsSlice = createSlice({
  name: 'windows',
  initialState: {
    selectedWindowId: -1,
  } as ExtraInitialState,
  reducers: {
    selectedWindowChanged: (state, { payload }) => {
      state.selectedWindowId = payload;
    },
  },
});

export const { selectedWindowChanged } = windowsSlice.actions;

export default windowsSlice.reducer;
